import { initials } from './format.ts';
import styles from './Avatar.module.css';

/**
 * Initials for a person (round) or an organization or workspace (square tile). Decorative: the
 * name beside it is the accessible text.
 */
export function Avatar({
  name,
  kind = 'person',
  size = 'medium',
}: {
  name: string;
  kind?: 'person' | 'place';
  size?: 'small' | 'medium' | 'large';
}) {
  return (
    <span className={styles.avatar} data-kind={kind} data-size={size} aria-hidden="true">
      {initials(name)}
    </span>
  );
}
